export const OWNER_ORGANIZATION_EMAIL = "visualize@bafu.admin.ch";
export const SUPPORT_EMAIL = "support@interactivethings.com";
